module.exports = __webpack_public_path__ + "img/mubang-1.d6557509.png";